import { useEffect } from "react";
import { WebsiteMemberDto } from "../../models/WebsiteModels";
import { resolveImageUrl } from "../../utils/ImageUrl";

interface PublicMemberModalProps {
  member: WebsiteMemberDto;
  onClose: () => void;
}

const PublicMemberModal = ({ member, onClose }: PublicMemberModalProps) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="psite-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={member.userName}
    >
      <div
        className="psite-modal__card"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="psite-modal__close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <div className="psite-modal__media">
          {member.profilePictureUrl ? (
            <img
              src={resolveImageUrl(member.profilePictureUrl)}
              alt={member.userName}
            />
          ) : (
            <span>{member.userName.charAt(0).toUpperCase()}</span>
          )}
        </div>
        <div className="psite-modal__body">
          <h3>{member.userName}</h3>
          <p className="psite-modal__title">
            {member.designation || member.roleName || "Member"}
          </p>
          {member.qualification && (
            <p className="psite-modal__qualification">
              {member.qualification}
            </p>
          )}
          {member.bio && <p className="psite-modal__bio">{member.bio}</p>}
          {!member.bio && !member.qualification && (
            <p className="psite-modal__bio">
              No additional details available for this member yet.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PublicMemberModal;